import withIndicador from "../../hoc/ControlCapacitaciones/withAjuste";
import Indicador from "../../view/components/Tablas/ControlCapacitaciones/AjustesCalidad/ListaIndicadores/Indicador";

export default withIndicador(Indicador);